import { MOBILE_SCREEN } from '@travel/traveler-core/hooks';
import { getDefaultURLSearchRequest, URL_KEYS } from '@travel/traveler-core/utils/jrdpHelper';

import { fetchHotelList } from 'store/hotelList/actions';
import { fetchHotelListMap, fetchSEOData } from 'store/hotelListMap/actions';
import { getSsrDeviceType } from 'store/userAgent/selectors';

import { HOTEL_LIST_SORT } from 'constants/sort';
import { getDefaultURLCustomListRequest, getHotelListValidSortValue } from 'utils/search';

import type { URLSearchQuery } from 'Common-Types';
import type { universalRouterProps } from 'core/universalRouter/types';
import type { RequestBody } from 'HotelList-Types';
import type { HotelListMapRequestBody } from 'HotelListMap-Types';
const DEFAULT_HOTEL_LIMIT = 30;

export type URLParams = { pageIdentifier: string; map?: string; pageNumber: number };

export default ({ store }: universalRouterProps, params: URLParams, urlParams: URLSearchQuery) => {
  const { dispatch, getState } = store;
  const isMobile = getSsrDeviceType(getState()) === MOBILE_SCREEN;

  const sortKey =
    urlParams?.[URL_KEYS.SORT] === 'recommended'
      ? HOTEL_LIST_SORT.provider_recommend.value
      : urlParams?.[URL_KEYS.SORT];

  const defaultURLSearchRequest = getDefaultURLSearchRequest(urlParams);
  const pageIdentifier = params.pageIdentifier;

  const hotelListQuery: RequestBody = {
    ...defaultURLSearchRequest,
    ...getDefaultURLCustomListRequest(urlParams),
    accommodationArea: pageIdentifier,
    sort: getHotelListValidSortValue(sortKey),
    offset: (params.pageNumber - 1) * DEFAULT_HOTEL_LIMIT,
    limit: DEFAULT_HOTEL_LIMIT,
    latitude: urlParams?.latitude,
    longitude: urlParams?.longitude,
    zoomLevel: urlParams?.zoomLevel,
  };

  const hotelListMapQuery: HotelListMapRequestBody = {
    ...defaultURLSearchRequest,
    ...getDefaultURLCustomListRequest(urlParams),
    accommodationArea: pageIdentifier,
    sort: getHotelListValidSortValue(sortKey),
    latitude: urlParams?.latitude,
    longitude: urlParams?.longitude,
    zoomLevel: urlParams?.zoomLevel,
  };
  dispatch(fetchSEOData());

  if (isMobile) {
    return Promise.all([dispatch(fetchHotelListMap(hotelListMapQuery))]);
  }

  return Promise.all([
    dispatch(fetchHotelList(hotelListQuery)),
    dispatch(fetchHotelListMap(hotelListMapQuery)),
  ]);
};
